import { formatPropertyAddress } from '../utils/propertyAddress';
import './MobileMapDisclosure.css';
import FleetPropertyDetailActions from './FleetPropertyDetailActions';
import {PropertyListPicker} from './PropertyLists';
import MapPlaceLayers from './MapPlaceLayers';
import {mapCoordinates} from '../utils/propertyCoordinates';
import PropertyLocationMap from './PropertyLocationMap';
import {addIllustratedBasemap} from '../services/illustratedBasemap';
import { propertyFetch } from '../services/idxPropertyClient';
import { loadPropertyMedia, propertyMediaUrls } from '../services/propertyMedia';
import { sendEmailRequest } from '../services/emailDeliveryService';
import { rememberPropertyPhoto } from '../services/propertyThumbnails';
import { getPropertyShareUrl } from '../utils/propertySharing';
import { usePropertySave } from './PropertySaveProvider';
import RobustSearchControls from './RobustSearchControls';
import useListSearchFilters from '../utils/useListSearchFilters';
import { searchFromQuery, searchQuery } from '../utils/propertySearchFilters';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { SITE_CONFIG } from '../config';
import PropertyThumbnail from './PropertyThumbnail';
import { decryptPassword } from '../utils/decrypt';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './PropertyListView.css';

// LEGACY_FAVORITES_CACHE_2026
const LOCAL_FAVORITES_KEY = `propertyFavorites_${SITE_CONFIG.SITE_ID}`;
const PropertyListView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDarkMode } = useTheme();
  const initialListFilters = location.state?.searchFilters || searchFromQuery(location.search);

  const [properties, setProperties] = useState(() => location.state?.properties || []);
  const [listViewPage, setListViewPage] = useState(0);
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [propertyDetailImages, setPropertyDetailImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(false);
  const detailRequestRef = useRef(0);
  const [likedProperties, setLikedProperties] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(LOCAL_FAVORITES_KEY) || '[]');
      return new Set(Array.isArray(saved) ? saved : []);
    } catch (error) {
      return new Set();
    }
  });
  const { favorites, toggleFavorite } = usePropertySave();
  useEffect(() => { setLikedProperties?.(favorites); }, [favorites]);
  const listSearch = useListSearchFilters({
    initialFilters: location.state?.searchFilters || searchFromQuery(location.search),
    initialProperties: location.state?.properties,
    quickEdits: {},
    defaultState: SITE_CONFIG.SEARCH_STATES || SITE_CONFIG.STATE,
    siteId: SITE_CONFIG.SITE_ID, onResults: setProperties, onPageReset: setListViewPage, pageSize:9
  });

  const [showLogin, setShowLogin] = useState(false);
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');

    const [expandedMap, setExpandedMap] = useState(null);
  const [placesExpandedMapInstance,setPlacesExpandedMapInstance]=useState(null);
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [enlargedImageIndex, setEnlargedImageIndex] = useState(0);
  const [showAiStaging, setShowAiStaging] = useState(false);
  const [isAdmin] = useState(() => {
    try { const u = JSON.parse(localStorage.getItem('user')); return u?.roles?.includes('ROLE_ADMIN') || u?.roles?.includes('ROLE_ASSISTANT') || false; } catch { return false; }
  });
  const [showEmailSendModal, setShowEmailSendModal] = useState(false);
  const [emailRecipient, setEmailRecipient] = useState('');
  const [emailCustomerName, setEmailCustomerName] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailPreviewHtml, setEmailPreviewHtml] = useState('');
  const [emailSending, setEmailSending] = useState(false);
  const [emailGenerating, setEmailGenerating] = useState(false);
  const [emailMode, setEmailMode] = useState('email');
  const [socialCopy, setSocialCopy] = useState(null);
  const [selectedListings, setSelectedListings] = useState(new Set());
  const [showBulkEmailModal, setShowBulkEmailModal] = useState(false);
  const [bulkEmailRecipient, setBulkEmailRecipient] = useState('');
  const [bulkEmailSubject, setBulkEmailSubject] = useState('');
  const [bulkEmailCustomerName, setBulkEmailCustomerName] = useState('');
  const [bulkEmailPreview, setBulkEmailPreview] = useState('');
  const [bulkEmailGenerating, setBulkEmailGenerating] = useState(false);
  const [bulkEmailSending, setBulkEmailSending] = useState(false);
  const [senderEmail, setSenderEmail] = useState('');
  const [senderPassword, setSenderPassword] = useState('');

  useEffect(() => {
    const fetchFlags = async () => {
      try {
        const res = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/feature-flag?siteId=${SITE_CONFIG.SITE_ID}`, { headers: { 'X-API-Key': 'treas-api-key-2025' } });
        if (res.ok) {
          const data = await res.json();
          if (data.senderEmail) setSenderEmail(data.senderEmail);
          if (data.senderEmailPassword) decryptPassword(data.senderEmailPassword).then(pw => { if (pw) setSenderPassword(pw); });
        }
      } catch (e) {}
    };
    fetchFlags();
  }, []);

  const openEnlargedImage = (url, index) => {
    setEnlargedImage(url);
    setEnlargedImageIndex(index);
  };

  const closeEnlargedImage = () => {
    setEnlargedImage(null);
    setStagingImage(null);
  };
  const [stagingImage, setStagingImage] = useState(null);
  const [stagingLoading, setStagingLoading] = useState(false);

  const handleAiStaging = async (type) => {
    setStagingLoading(true);
    try {
      const promptResponse = await fetch(`https://tophamtechbeb.com/api/stage/v1/${type}-prompts/random`, {
        headers: { 'X-API-Key': 'treas-api-key-2025' }
      });

      if (!promptResponse.ok) throw new Error('Failed to get staging prompt');

      const promptData = await promptResponse.json();
      const formData = new FormData();
      formData.append('image_url', enlargedImage);
      formData.append('design_prompt', promptData.prompt);

      const stagingResponse = await fetch('https://tophamtechbeb.com/api/stage/v1/stage-room', {
        method: 'POST',
        headers: { 'X-API-Key': 'treas-api-key-2025' },
        body: formData
      });

      if (!stagingResponse.ok) throw new Error('Failed to stage room');

      const stagedBlob = await stagingResponse.blob();
      const imageUrl = URL.createObjectURL(stagedBlob);
      setStagingImage(imageUrl);
      setShowAiStaging(false);
    } catch (error) {
      console.error('Error staging room:', error);
      alert('Failed to stage room. Please try again.');
    } finally {
      setStagingLoading(false);
    }
  };

  const fetchPropertyDetail = async (propertyId, summaryData) => {
    const requestId = ++detailRequestRef.current;
    const cover = summaryData?.first_photo_url || summaryData?.image_url || summaryData?.photo_url;
    setPropertyDetail(summaryData || null);
    setPropertyDetailImages(cover ? [cover] : []);
    setImagesLoading(!cover);
    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-data/${propertyId}`, {});
      if (requestId !== detailRequestRef.current) return;
      if (response.ok) {
        const data = await response.json();
        const property = data.properties[0];
        setPropertyDetail({
          ...property,
          created_at: property.created_at || summaryData?.created_at,
          updated_at: property.updated_at || summaryData?.updated_at
        });
        if (property.listing_key) {
          fetchAllPropertyImages(property.listing_key, requestId, cover);
        }
      } else {
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching property details:', error);
      if (requestId === detailRequestRef.current) setImagesLoading(false);
    }
  };

  const fetchAllPropertyImages = async (listingKey, requestId, cover) => {
    try {
      const images = propertyMediaUrls(await loadPropertyMedia(listingKey));
      if (requestId !== detailRequestRef.current) return;
      if (images.length > 0) {
          const firstThree = images.slice(0, 3);
          setPropertyDetailImages(firstThree);
          setImagesLoading(false);
          rememberPropertyPhoto(listingKey, images[0]);
          if (images.length > 3) {
            setTimeout(() => {
              if (requestId === detailRequestRef.current) setPropertyDetailImages(images);
            }, 500);
          }
      } else {
        setPropertyDetailImages(cover ? [cover] : []);
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching all property images:', error);
      if (requestId === detailRequestRef.current) {
        setPropertyDetailImages(cover ? [cover] : []);
        setImagesLoading(false);
      }
    }
  };

  const closePropertyDetail = () => {
    detailRequestRef.current += 1;
    setPropertyDetail(null);
    setImagesLoading(false);
  };

  useEffect(() => {
    if (location.state?.properties) {
      setProperties(location.state.properties);
    }
  }, [location.state]);

  const user = location.state?.user;

  const getTileCoords = (lat, lon, zoom) => {
    const x = Math.floor((lon + 180) / 360 * Math.pow(2, zoom));
    const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));
    return { x, y };
  };

  useEffect(() => {
    if (expandedMap && mapRef.current) {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
      }

      const map = L.map(mapRef.current,{minZoom:1,maxZoom:19}).setView([expandedMap.lat, expandedMap.lon], 15);

      addIllustratedBasemap(map);

      const houseIcon = L.divIcon({
        html: '🏠',
        className: 'house-marker',
        iconSize: [30, 30],
        iconAnchor: [15, 15]
      });

      L.marker([expandedMap.lat, expandedMap.lon], { icon: houseIcon }).addTo(map);

      leafletMapRef.current = map;
      setPlacesExpandedMapInstance(map);
    }

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
        setPlacesExpandedMapInstance(null);
      }
    };
  }, [expandedMap]);

  return (
    <div className={`property-list-view ${isDarkMode ? 'dark-mode' : ''}`}>
      <div style={{padding:'12px 20px'}}><RobustSearchControls filters={listSearch.filters} onChange={listSearch.setFilters} scope={{state:listSearch.filters.state || SITE_CONFIG.SEARCH_STATES || SITE_CONFIG.STATE, propertyType:listSearch.filters.propertyType || 'Residential'}} />
      {listSearch.loading && <p role="status">Loading matching homes…</p>}
      {listSearch.error && <p role="alert">{listSearch.error}</p>}</div>

      <div className="list-view-navigation">
        <button type="button" className="back-to-map-btn"
          onClick={() => {if(location.state?.isSavedHomes && location.state?.savedMap){sessionStorage.setItem('globeMapData',JSON.stringify(location.state.savedMap));navigate('/search?saved=true');}else{const params=searchQuery(listSearch.filters);params.set('view','map');navigate(`/search?${params}`);}}}>
          🗺 Map View
        </button>
        <button type="button" className="back-to-map-btn"
          onClick={() => {const params=searchQuery(listSearch.filters);params.set('view','filters');navigate(`/search?${params}`);}}>
          ← Search Filters
        </button>
      </div>

      <div className="list-view-container">
        {properties.slice(listViewPage * 9, (listViewPage + 1) * 9).map((property, index) => {
          return (
            <div
              key={index}
              className="list-view-card"
              onClick={() => fetchPropertyDetail(property.id, property)}
            >
              {isAdmin && (
                <div
                  className="list-view-select"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedListings(prev => {
                      const next = new Set(prev);
                      if (next.has(property.listing_key)) next.delete(property.listing_key);
                      else if (next.size < 3) next.add(property.listing_key);
                      return next;
                    });
                  }}
                >
                  <input type="checkbox" checked={selectedListings.has(property.listing_key)} readOnly />
                </div>
              )}
              <div className="list-view-hero">
                <PropertyThumbnail
                  listingKey={property.listing_key}
                  src={property.first_photo_url || property.image_url || property.photo_url}
                  alt={`Property at ${property.address || property.street_address}`}
                  className="list-view-image"
                />
                <div className="list-view-overlay">
                  <div className="list-view-price">
                    ${property.current_price?.toLocaleString() || property.price}
                  </div>
                  <div className="list-view-address">
                    {formatPropertyAddress(property)}
                  </div>
                  <div className="list-view-meta">
                    {property.bedrooms_total && <span>🛏️ {property.bedrooms_total} bed</span>}
                    {property.property_type && <span>{property.property_type}</span>}
                  </div>
                </div>
                {property.latitude && property.longitude && (
                  <div
                    className="list-view-map"
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpandedMap({lat: property.latitude, lon: property.longitude, address: property.address});
                    }}
                  >
                    <img
                      src={`https://tile.openstreetmap.org/15/${getTileCoords(property.latitude, property.longitude, 15).x}/${getTileCoords(property.latitude, property.longitude, 15).y}.png`}
                      alt={`Map location for ${property.address || property.street_address}`}
                    />
                    <div className="list-view-house-icon">🏠</div>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className="pagination-controls">
          {listSearch.restartSearch && <button onClick={()=>listSearch.restart()}>Restart search</button>}
          {listViewPage > 0 && (
            <button
              disabled={listSearch.loading} onClick={() => setListViewPage(listViewPage - 1)}
              className="pagination-btn"
            >
              ← Previous
            </button>
          )}
          <span className="pagination-info">
            Page {listViewPage + 1}
          </span>
          {(listSearch.hasMore || (listViewPage + 1) * 9 < properties.length) && (
            <button
              disabled={listSearch.loading} onClick={() => listSearch.nextPage(listViewPage)}
              className="pagination-btn"
            >
              Next →
            </button>
          )}
        </div>
        <div className="mobile-map-disclosure" style={{gridColumn: '1 / -1', background: 'rgba(0,0,0,0.85)', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', borderRadius: '8px'}}>
          <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '20px', objectFit: 'contain'}} />
          <span style={{fontSize: '10px', color: '#ccc', flex: 1}}>{SITE_CONFIG.MLS.DISCLAIMER} | Brokerage License: {SITE_CONFIG.AGENT.BROKERAGE_LICENSE} | Agent License: {SITE_CONFIG.AGENT.LICENSE}</span>
        </div>
      </div>

      {isAdmin && selectedListings.size > 0 && (
        <div className="bulk-email-bar">
          <span>{selectedListings.size}/3 selected</span>
          <button onClick={() => { setBulkEmailSubject('Featured Properties'); setBulkEmailPreview(''); setShowBulkEmailModal(true); }}>
            ✉️ Email Selected
          </button>
          <button onClick={() => setSelectedListings(new Set())}>Clear</button>
        </div>
      )}

      {showBulkEmailModal && (
        <div className="modal-overlay" onClick={() => setShowBulkEmailModal(false)}>
          <div className="email-send-modal" style={{position: 'relative', margin: 'auto', top: '20vh'}} onClick={(e) => e.stopPropagation()}>
            <div className="email-send-modal-content">
              <button className="email-send-modal-close" onClick={() => setShowBulkEmailModal(false)}>×</button>
              <h3>Email {selectedListings.size} Properties</h3>
              {bulkEmailPreview === 'sent' ? (
                <div style={{textAlign: 'center', padding: '30px 10px'}}>
                  <div style={{fontSize: '40px', marginBottom: '10px'}}>✅</div>
                  <p style={{color: '#28a745', fontWeight: 600, margin: 0}}>Email sent successfully!</p>
                </div>
              ) : !bulkEmailPreview ? (
                <div className="email-send-form">
                  <input type="email" placeholder="Recipient email *" value={bulkEmailRecipient} onChange={(e) => setBulkEmailRecipient(e.target.value)} />
                  <input type="text" placeholder="Customer name (optional)" value={bulkEmailCustomerName} onChange={(e) => setBulkEmailCustomerName(e.target.value)} />
                  <input type="text" placeholder="Subject *" value={bulkEmailSubject} onChange={(e) => setBulkEmailSubject(e.target.value)} />
                  <button
                    disabled={!bulkEmailRecipient.trim() || !bulkEmailSubject.trim() || bulkEmailGenerating}
                    onClick={async () => {
                      setBulkEmailGenerating(true);
                      try {
                        const res = await fetch('https://tophamtechbe.com/api/treas/comm/property-search-preview?format=html', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json', 'X-API-Key': 'treas-api-key-2025' },
                          body: JSON.stringify({
                            customerName: bulkEmailCustomerName || undefined,
                            agentName: SITE_CONFIG.AGENT.NAME,
                            siteId: SITE_CONFIG.SITE_ID,
                            listingBaseUrl: `https://www.${SITE_CONFIG.BASE_URL}`,
                            searchFilters: { listingKey: [...selectedListings].join(',') }
                          })
                        });
                        const data = await res.json();
                        if (data.html) setBulkEmailPreview(data.html);
                        else alert(data.message || 'No preview generated');
                      } catch (err) {
                        alert('Error generating preview');
                      }
                      setBulkEmailGenerating(false);
                    }}
                  >
                    {bulkEmailGenerating ? 'Generating...' : 'Preview Email'}
                  </button>
                </div>
              ) : (
                <div className="email-send-preview">
                  <iframe title="Email Preview" srcDoc={bulkEmailPreview} style={{width: '100%', height: '300px', border: '1px solid #ddd', borderRadius: '4px'}} />
                  <div className="email-send-actions">
                    <button onClick={() => setBulkEmailPreview('')}>← Back</button>
                    <button
                      disabled={bulkEmailSending}
                      onClick={async () => {
                        setBulkEmailSending(true);
                        try {
                          const formData = new FormData();
                          formData.append('emailaddress', bulkEmailRecipient);
                          formData.append('title', bulkEmailSubject);
                          formData.append('body', bulkEmailPreview);
                          if (senderEmail) formData.append('email', senderEmail);
                          if (senderPassword) formData.append('emailPassword', senderPassword);
                          const res = await sendEmailRequest('https://tophamtechbe.com/api/treas/comm/send-email', {
                            method: 'POST',
                            headers: { 'X-API-Key': 'treas-api-key-2025' },
                            body: formData
                          });
                          if (res.ok) {
                            setBulkEmailPreview('sent');
                            setTimeout(() => { setShowBulkEmailModal(false); setSelectedListings(new Set()); }, 2000);
                          } else alert('Failed to send email');
                        } catch (err) {
                          alert('Error sending email');
                        }
                        setBulkEmailSending(false);
                      }}
                    >
                      {bulkEmailSending ? 'Sending...' : 'Send Email'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {propertyDetail && (
        <div className="modal-overlay" onClick={closePropertyDetail}>
          <><FleetPropertyDetailActions home={propertyDetail} user={user} /><div className="property-detail-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closePropertyDetail}>×</button>
            <button
              className="link-button"
              onClick={() => {
                const url = getPropertyShareUrl(propertyDetail, SITE_CONFIG);
                navigator.clipboard.writeText(url).then(() => {
                  alert('Link copied!');
                }).catch(() => alert('Failed to copy link'));
              }}
              aria-label="Copy property link to clipboard"
            >
              🔗
            </button>
            <button
              className={`heart-button ${likedProperties.has(propertyDetail.listing_key) ? 'liked' : ''}`}
              onClick={(e) => { e.stopPropagation(); toggleFavorite(propertyDetail); }}
            >
              {likedProperties.has(propertyDetail.listing_key) ? '💖' : '❤️'}
            </button>
            {isAdmin && (
              <button
                className="email-send-button"
                onClick={() => {
                  setEmailSubject(`Property Listing - ${formatPropertyAddress(propertyDetail)}`);
                  setEmailRecipient('');
                  setEmailCustomerName('');
                  setEmailPreviewHtml('');
                  setShowEmailSendModal(true);
                }}
                aria-label="Send property email"
              >
                ✉️
              </button>
            )}
            {showEmailSendModal && (
              <div className="email-send-modal" onClick={(e) => e.stopPropagation()}>
                <div className="email-send-modal-content">
                  <button className="email-send-modal-close" onClick={() => { setShowEmailSendModal(false); setSocialCopy(null); }}>×</button>
                  <div className="email-send-tabs">
                    <button className={emailMode === 'email' ? 'active' : ''} onClick={() => { setEmailMode('email'); setSocialCopy(null); }}>Email</button>
                    <button className={emailMode === 'social' ? 'active' : ''} onClick={() => { setEmailMode('social'); setEmailPreviewHtml(''); }}>Social</button>
                  </div>
                  {emailMode === 'email' ? (
                    <>
                      {emailPreviewHtml === 'sent' ? (
                        <div style={{textAlign: 'center', padding: '30px 10px'}}>
                          <div style={{fontSize: '40px', marginBottom: '10px'}}>✅</div>
                          <p style={{color: '#28a745', fontWeight: 600, margin: 0}}>Email sent successfully!</p>
                        </div>
                      ) : !emailPreviewHtml ? (
                        <div className="email-send-form">
                          <input type="email" placeholder="Recipient email *" value={emailRecipient} onChange={(e) => setEmailRecipient(e.target.value)} />
                          <input type="text" placeholder="Customer name (optional)" value={emailCustomerName} onChange={(e) => setEmailCustomerName(e.target.value)} />
                          <input type="text" placeholder="Subject *" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} />
                          <button
                            disabled={!emailRecipient.trim() || !emailSubject.trim() || emailGenerating}
                            onClick={async () => {
                              setEmailGenerating(true);
                              try {
                                const res = await fetch('https://tophamtechbe.com/api/treas/comm/property-search-preview?format=html', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json', 'X-API-Key': 'treas-api-key-2025' },
                                  body: JSON.stringify({
                                    customerName: emailCustomerName || undefined,
                                    agentName: SITE_CONFIG.AGENT.NAME,
                                    siteId: SITE_CONFIG.SITE_ID,
                                    listingBaseUrl: `https://www.${SITE_CONFIG.BASE_URL}`,
                                    searchFilters: { listingKey: propertyDetail.listing_key }
                                  })
                                });
                                const data = await res.json();
                                if (data.html) {
                                  setEmailPreviewHtml(data.html);
                                } else {
                                  alert(data.message || 'No preview generated');
                                }
                              } catch (err) {
                                alert('Error generating preview');
                              }
                              setEmailGenerating(false);
                            }}
                          >
                            {emailGenerating ? 'Generating...' : 'Preview Email'}
                          </button>
                        </div>
                      ) : (
                        <div className="email-send-preview">
                          <iframe title="Email Preview" srcDoc={emailPreviewHtml} style={{width: '100%', height: '300px', border: '1px solid #ddd', borderRadius: '4px'}} />
                          <div className="email-send-actions">
                            <button onClick={() => setEmailPreviewHtml('')}>← Back</button>
                            <button
                              disabled={emailSending}
                              onClick={async () => {
                                setEmailSending(true);
                                try {
                                  const formData = new FormData();
                                  formData.append('emailaddress', emailRecipient);
                                  formData.append('title', emailSubject);
                                  formData.append('body', emailPreviewHtml);
                                  if (senderEmail) formData.append('email', senderEmail);
                                  if (senderPassword) formData.append('emailPassword', senderPassword);
                                  const res = await sendEmailRequest('https://tophamtechbe.com/api/treas/comm/send-email', {
                                    method: 'POST',
                                    headers: { 'X-API-Key': 'treas-api-key-2025' },
                                    body: formData
                                  });
                                  if (res.ok) {
                                    setEmailPreviewHtml('sent');
                                    setTimeout(() => setShowEmailSendModal(false), 2000);
                                  } else {
                                    alert('Failed to send email');
                                  }
                                } catch (err) {
                                  alert('Error sending email');
                                }
                                setEmailSending(false);
                              }}
                            >
                              {emailSending ? 'Sending...' : 'Send Email'}
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="email-send-form">
                      {!socialCopy ? (
                        <button
                          disabled={emailGenerating}
                          onClick={async () => {
                            setEmailGenerating(true);
                            try {
                              const res = await fetch('https://tophamtechbe.com/api/treas/comm/property-search-preview?format=social', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'X-API-Key': 'treas-api-key-2025' },
                                body: JSON.stringify({
                                  agentName: SITE_CONFIG.AGENT.NAME,
                                  siteId: SITE_CONFIG.SITE_ID,
                                  listingBaseUrl: `https://www.${SITE_CONFIG.BASE_URL}`,
                                  searchFilters: { listingKey: propertyDetail.listing_key }
                                })
                              });
                              const data = await res.json();
                              if (data.text) {
                                setSocialCopy(data);
                              } else {
                                alert(data.message || 'No content generated');
                              }
                            } catch (err) {
                              alert('Error generating social copy');
                            }
                            setEmailGenerating(false);
                          }}
                        >
                          {emailGenerating ? 'Generating...' : 'Generate Social Post'}
                        </button>
                      ) : (
                        <div className="social-copy-result">
                          <textarea readOnly value={socialCopy.text} style={{width: '100%', height: '150px', resize: 'none', borderRadius: '6px', border: '1px solid #ddd', padding: '10px', fontSize: '13px', boxSizing: 'border-box'}} />
                          {socialCopy.images?.length > 0 && (
                            <div style={{display: 'flex', gap: '6px', marginTop: '8px', overflowX: 'auto'}}>
                              {socialCopy.images.map((img, i) => (
                                <div key={i} style={{position: 'relative', flexShrink: 0}}>
                                  <img src={img} alt="" style={{height: '60px', borderRadius: '4px'}} />
                                  <button onClick={() => window.open(img, '_blank')} style={{position: 'absolute', bottom: '2px', right: '2px', background: 'rgba(0,0,0,0.6)', color: '#fff', borderRadius: '4px', padding: '2px 5px', fontSize: '10px', border: 'none', cursor: 'pointer'}}>⬇</button>
                                </div>
                              ))}
                            </div>
                          )}
                          <button
                            style={{marginTop: '10px'}}
                            onClick={() => { navigator.clipboard.writeText(socialCopy.text); }}
                          >
                            📋 Copy Text
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="property-detail-content">
              <div className="property-header">
<div className={`property-overview-grid${mapCoordinates(propertyDetail) ? '' : ' property-overview-grid--no-map'}`}><div className="property-overview-summary">
                {!propertyDetail.isPrivate && (propertyDetail.list_agent_full_name || propertyDetail.list_office_name) && (
                  <div style={{fontSize: '11px', color: '#888', marginBottom: '6px', textAlign: 'left'}}>
                    {propertyDetail.list_agent_full_name && (
                      <div>Listing Agent: {propertyDetail.list_agent_full_name}{propertyDetail.list_agent_mls_id ? ` (${propertyDetail.list_agent_mls_id})` : ''}</div>
                    )}
                    {propertyDetail.list_office_name && (
                      <div>Office: {propertyDetail.list_office_name}</div>
                    )}
                  </div>
                )}
                <h2>${propertyDetail.current_price?.toLocaleString()}</h2>
                <p className="property-address">{formatPropertyAddress(propertyDetail)}</p>

                </div><PropertyLocationMap property={propertyDetail} /></div>
<div className="property-images">
                  {imagesLoading ? (
                    <div style={{textAlign: 'center', padding: '20px', color: '#007bff', fontSize: '14px'}}>
                      <div style={{display: 'inline-block', marginRight: '8px', animation: 'spin 1s linear infinite', fontSize: '16px'}}>⟳</div>
                      Loading images...
                    </div>
                  ) : propertyDetailImages.length > 0 ? (
                    propertyDetailImages.map((imageUrl, index) => (
                      <div key={index} className="property-detail-image" onClick={() => openEnlargedImage(imageUrl, index)}>
                        <img src={imageUrl} alt={`Property ${index + 1}`} onLoad={() => rememberPropertyPhoto(propertyDetail?.listing_key, imageUrl)} />
                      </div>
                    ))
                  ) : (
                    <div style={{textAlign: 'center', padding: '20px', color: '#666', fontSize: '14px'}}>
                      No images available
                    </div>
                  )}
                </div>

                {propertyDetail.features?.public_remarks && (
                  <div className="property-description">
                    <h3>Property Description</h3>
                    <p>{propertyDetail.features.public_remarks}</p>
                  </div>
                )}
              </div>

              <div className="property-columns">
                <div className="property-column">
                  <h3>Property Details</h3>
                  <p><strong>Property Type:</strong> {propertyDetail.property_type}</p>
                  {propertyDetail.property_sub_type && <p><strong>Property Sub Type:</strong> {propertyDetail.property_sub_type}</p>}
                  <p><strong>Listing Key:</strong> {propertyDetail.listing_key}</p>
                  <p><strong>Current Price:</strong> ${propertyDetail.current_price?.toLocaleString()}</p>
                  <p><strong>List Price:</strong> ${propertyDetail.list_price?.toLocaleString()}</p>
                  {propertyDetail.original_list_price && <p><strong>Original List Price:</strong> ${propertyDetail.original_list_price?.toLocaleString()}</p>}
                  <p><strong>Living Area:</strong> {propertyDetail.living_area} sq ft</p>
                  <p><strong>Building Area:</strong> {propertyDetail.building_area_total} sq ft</p>
                  <p><strong>Year Built:</strong> {propertyDetail.year_built}</p>
                  {propertyDetail.stories && <p><strong>Stories:</strong> {propertyDetail.stories}</p>}
                  {propertyDetail.days_on_market && <p><strong>Days on Market:</strong> {propertyDetail.days_on_market}</p>}
                  {(propertyDetail.updated_at || propertyDetail.created_at) && <p><strong>Last Updated:</strong> {new Date(propertyDetail.updated_at || propertyDetail.created_at).toLocaleString()}</p>}

                  {propertyDetail.land && (
                    <div>
                      <h3>Land Details</h3>
                      {propertyDetail.land.lot_size_acres && <p><strong>Lot Size:</strong> {propertyDetail.land.lot_size_acres} acres ({propertyDetail.land.lot_size_square_feet?.toLocaleString()} sq ft)</p>}
                      {propertyDetail.land.lot_features && <p><strong>Lot Features:</strong> {propertyDetail.land.lot_features}</p>}
                      {propertyDetail.land.zoning && <p><strong>Zoning:</strong> {propertyDetail.land.zoning}</p>}
                    </div>
                  )}

                  <h3>Rooms & Bathrooms</h3>
                  {propertyDetail.bedrooms_total != null && <p><strong>Bedrooms:</strong> {propertyDetail.bedrooms_total}</p>}
                  {propertyDetail.bathrooms_full != null && <p><strong>Full Bathrooms:</strong> {propertyDetail.bathrooms_full}</p>}
                  {propertyDetail.bathrooms_half != null && <p><strong>Half Bathrooms:</strong> {propertyDetail.bathrooms_half}</p>}
                  {propertyDetail.fireplaces_total != null && <p><strong>Fireplaces:</strong> {propertyDetail.fireplaces_total}</p>}

                  {propertyDetail.schools && (
                    <div>
                      <h3>Schools</h3>
                      <p><strong>Elementary:</strong> {propertyDetail.schools.elementary_school}</p>
                      <p><strong>Middle:</strong> {propertyDetail.schools.middle_school}</p>
                      <p><strong>High:</strong> {propertyDetail.schools.high_school}</p>
                    </div>
                  )}
                </div>

                <div className="property-column">
                  <h3>Features & Amenities</h3>
                  {propertyDetail.features?.garage_spaces != null && <p><strong>Garage:</strong> {propertyDetail.features.garage_spaces} spaces</p>}
                  {propertyDetail.features?.heating && <p><strong>Heating:</strong> {propertyDetail.features.heating}</p>}
                  {propertyDetail.features?.cooling && <p><strong>Cooling:</strong> {propertyDetail.features.cooling}</p>}
                  {propertyDetail.features?.water_source && <p><strong>Water Source:</strong> {propertyDetail.features.water_source}</p>}
                  {propertyDetail.foundation_details && <p><strong>Foundation:</strong> {propertyDetail.foundation_details}</p>}
                  {propertyDetail.roof && <p><strong>Roof:</strong> {propertyDetail.roof}</p>}
                  {propertyDetail.sewer && <p><strong>Sewer:</strong> {propertyDetail.sewer}</p>}

                  {propertyDetail.features?.appliances && (
                    <div>
                      <h3>Appliances</h3>
                      <p className="feature-list">{propertyDetail.features.appliances.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.interior_features && (
                    <div>
                      <h3>Interior Features</h3>
                      <p className="feature-list">{propertyDetail.features.interior_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.exterior_features && (
                    <div>
                      <h3>Exterior Features</h3>
                      <p className="feature-list">{propertyDetail.features.exterior_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.fencing && (
                    <div>
                      <h3>Fencing</h3>
                      <p>{propertyDetail.features.fencing}</p>
                    </div>
                  )}

                  {propertyDetail.association?.association_name && (
                    <div>
                      <h3>HOA Information</h3>
                      <p><strong>Association:</strong> {propertyDetail.association.association_name}</p>
                      {propertyDetail.association.association_fee && <p><strong>HOA Fee:</strong> ${propertyDetail.association.association_fee} {propertyDetail.association.fee_frequency}</p>}
                    </div>
                  )}

                  {propertyDetail.features?.lots_features && (
                    <div>
                      <h3>Lot Features</h3>
                      <p className="feature-list">{propertyDetail.features.lots_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.patio_and_porch_features && (
                    <div>
                      <h3>Patio & Porch</h3>
                      <p className="feature-list">{propertyDetail.features.patio_and_porch_features.split(',').join(', ')}</p>
                    </div>
                  )}
                </div>
              </div>
              {!propertyDetail.isPrivate && (
                <div style={{borderTop: '1px solid #ddd', marginTop: '20px', paddingTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                  <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '32px', objectFit: 'contain'}} />
                  <div style={{fontSize: '12px', color: '#666', flex: 1}}>
                    <span>{SITE_CONFIG.MLS.DISCLAIMER}</span>
                  </div>
                </div>
              )}
            </div>
          </div></>
        </div>
      )}

      {enlargedImage && (
        <div className="gallery-overlay" onClick={closeEnlargedImage}>
          <div className="gallery-container" onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => { e.currentTarget.dataset.touchStartX = e.touches[0].clientX; }}
            onTouchEnd={(e) => {
              const startX = parseFloat(e.currentTarget.dataset.touchStartX);
              const endX = e.changedTouches[0].clientX;
              const diff = startX - endX;
              if (Math.abs(diff) > 50 && propertyDetailImages.length > 1) {
                if (diff > 0) {
                  const nextIndex = enlargedImageIndex < propertyDetailImages.length - 1 ? enlargedImageIndex + 1 : 0;
                  setEnlargedImageIndex(nextIndex);
                  setEnlargedImage(propertyDetailImages[nextIndex]);
                } else {
                  const prevIndex = enlargedImageIndex > 0 ? enlargedImageIndex - 1 : propertyDetailImages.length - 1;
                  setEnlargedImageIndex(prevIndex);
                  setEnlargedImage(propertyDetailImages[prevIndex]);
                }
                setStagingImage(null);
              }
            }}
          >
            <div className="gallery-top-bar">
              <span className="gallery-counter">{enlargedImageIndex + 1} / {propertyDetailImages.length}</span>
              <div className="gallery-top-actions">
                <button className={`gallery-btn gallery-heart ${likedProperties.has(propertyDetail?.listing_key) ? 'liked' : ''}`}
                  onClick={(e) => { e.stopPropagation(); toggleFavorite(propertyDetail); }}
                >{likedProperties.has(propertyDetail?.listing_key) ? '💖' : '🤍'}</button>
                <button className="gallery-btn" onClick={() => setShowAiStaging(true)}>🤖</button>
                <button className="gallery-btn" onClick={closeEnlargedImage}>✕</button>
              </div>
            </div>
            <img src={stagingImage || enlargedImage} alt="Property" className="gallery-image" />
            {stagingImage && (
              <button className="reset-staging-button" onClick={() => setStagingImage(null)}>Original</button>
            )}
            {propertyDetailImages.length > 1 && (
              <>
                <button className="gallery-arrow gallery-prev" onClick={() => {
                  const prevIndex = enlargedImageIndex > 0 ? enlargedImageIndex - 1 : propertyDetailImages.length - 1;
                  setEnlargedImageIndex(prevIndex);
                  setEnlargedImage(propertyDetailImages[prevIndex]);
                  setStagingImage(null);
                }}>‹</button>
                <button className="gallery-arrow gallery-next" onClick={() => {
                  const nextIndex = enlargedImageIndex < propertyDetailImages.length - 1 ? enlargedImageIndex + 1 : 0;
                  setEnlargedImageIndex(nextIndex);
                  setEnlargedImage(propertyDetailImages[nextIndex]);
                  setStagingImage(null);
                }}>›</button>
              </>
            )}
          </div>
        </div>
      )}

      {showAiStaging && (
        <div className="ai-staging-modal" onClick={() => setShowAiStaging(false)}>
          <div className="ai-staging-content" onClick={(e) => e.stopPropagation()}>
            <h3>AI Room Staging</h3>
            <p>Select room type to generate AI staging:</p>
            <div className="staging-buttons">
              <button className="staging-type-button" onClick={() => handleAiStaging('bedroom')} disabled={stagingLoading}>🛌️ Bedroom</button>
              <button className="staging-type-button" onClick={() => handleAiStaging('office')} disabled={stagingLoading}>💼 Office</button>
              <button className="staging-type-button" onClick={() => handleAiStaging('landscape')} disabled={stagingLoading}>🌳 Landscape</button>
              <button className="staging-type-button" onClick={() => handleAiStaging('room')} disabled={stagingLoading}>🏠 Room</button>
            </div>
            {stagingLoading && (
              <div className="staging-loading">
                <div className="loading-spinner"></div>
                <p>Generating AI staging...</p>
              </div>
            )}
            <button className="close-staging-modal" onClick={() => setShowAiStaging(false)}>Cancel</button>
          </div>
        </div>
      )}

      {expandedMap && (
        <div className="modal-overlay" onClick={() => setExpandedMap(null)}>
          <div className="expanded-map" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setExpandedMap(null)}>×</button>
            <div ref={mapRef} className="leaflet-map"></div>
              <MapPlaceLayers map={placesExpandedMapInstance} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyListView;
